'use client';

import { useRef, useState, type ReactElement, type ReactNode } from 'react';
import { TbCloudDownload, TbEye, TbReportAnalytics } from 'react-icons/tb';

import { Modal } from '@/components/ui/modal';

interface Props {
  html: string;
  periodFrom: string | null; // ISO yyyy-mm-dd
  periodTo: string | null;
  generatedAt: string | null;
  /** Trigger custom; default = botão gradiente "Abrir relatório". */
  trigger?: ReactNode;
}

export function ReportViewerDialog({ html, periodFrom, periodTo, trigger }: Props): ReactElement {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [open, setOpen] = useState(false);

  function handlePrint(): void {
    const win = iframeRef.current?.contentWindow;
    if (!win) return;
    win.focus();
    win.print();
  }

  return (
    <>
      <span onClick={() => setOpen(true)} className="contents">
        {trigger ?? (
          <button
            type="button"
            className="bg-trakd-fill shadow-trakd-glow-subtle text-on-brand inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium hover:opacity-90"
          >
            <TbEye size={16} /> Abrir relatório
          </button>
        )}
      </span>

      <Modal
        open={open}
        onOpenChange={setOpen}
        title="Relatório diário"
        description={
          periodFrom && periodTo ? (
            <>
              {br(periodFrom)} → {br(periodTo)}
            </>
          ) : (
            'Último dia'
          )
        }
        icon={<TbReportAnalytics size={17} strokeWidth={1.7} />}
        tone="brand"
        size="lg"
        footer={
          <button
            type="button"
            onClick={handlePrint}
            className="bg-trakd-fill shadow-trakd-glow-subtle text-on-brand inline-flex shrink-0 items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold hover:opacity-90"
          >
            <TbCloudDownload size={16} strokeWidth={1.7} /> Salvar PDF
          </button>
        }
      >
        <iframe
          ref={iframeRef}
          title="Relatório Trakd"
          srcDoc={html}
          className="h-[70vh] w-full rounded-lg bg-white"
        />
      </Modal>
    </>
  );
}

// ISO yyyy-mm-dd -> dd/mm/yyyy
function br(iso: string): string {
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[3]}/${m[2]}/${m[1]}`;
}
